import '../custom.css';
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams  } from 'react-router';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import logo from '../components/Images/logo.png';


export default function RequestPwdReset () {
    const [retypePassword, setRetypePassword] = useState();
    const [email, setPassword] = useState();
    const [loginErrorMessage, setLoginErrorMessage] = useState();
    const [loginStatusCode, setLoginStatusCode] = useState();
    const navigate = useNavigate();
    const { magicKey } = useParams();
    const handleSubmit = async e => {
        e.preventDefault();
        resetPasswordRequest({
            email
        });
        
    }
    function resetPasswordRequest(credentials) {
        fetch('api/requestpwdreset', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
            .then(data => {
                if (data.status != 200) {
                    data.json()
                        .then((error) => {
                            setLoginStatusCode(data.status)
                            setLoginErrorMessage(error.errors)

                        })

                }
                else {
                    navigate("/");
                }




            })
            

    }

    return (

        <Box mt={2}
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off">
            <div className="login-wrapper">
                <Card sx={{ maxWidth: 700, textAlign:'center' }}>
                    <CardMedia
                        component="img"
                        alt="green iguana"
                        height="140"
                        className="loginCard"
                        image={logo}
                    />
                    <CardContent>
                        <Box sx={{ textAlign: '-webkit-center', width: '100%' }}>
                            {loginStatusCode && loginStatusCode != 200  &&
                                <Typography color="error" variant="body2" gutterBottom>
                                    {loginStatusCode + ": " + loginErrorMessage}
                                </Typography>
                            }
                        <Typography variant="h5" gutterBottom>
                            Request password reset
                            </Typography>
                            </Box>
                    </CardContent>
                    <CardActions sx={{ display: 'inline-grid' }}>
                        
                            
                            
                      

                                <TextField
                                    required
                                    value={email}
                                    id="password-input"
                                    label="Enter your email"
                                    type="email"
                                    onChange={e => setPassword(e.target.value)}
                                />
                            

                        <Button disabled={email  ? false : true} size="large" type="submit" onClick={handleSubmit} variant="contained" color='neutral' >
                                    Reset Password
                                </Button>
                            
                       
                    </CardActions>
                </Card>
                        
                    </div>
                </Box>

         


        
    )
}

